import ProductInquireBottomSheet from './ProductInquireBottomSheet';

export { default } from './ProductInquire';
export { ProductInquireBottomSheet };
